import React, { useState } from 'react';
import {
    ListRow,
    RowIcon,
    RowInfoStack,
    RowH1,
    // TeamCard,
    // TextWrapper,
    // TopLine,
    // FormH4,
    SelectButton,
    Img,
    PlayerName,
    PlayerCost,
    RemoveButton,
    ListRowSlot,
    ColInfoStack,
    // DetailsWrap,
    // StatsWrap,
    // ImgWrap,
    // Img
} from './CaptainTeamTableElements';
import teamLogos from '../LogoImageForms/TeamLogos';
import List from '@mui/material/List';

const CaptainTableRow = ({ player, position, index, handleRemove, handleFill, setFocusAsset = null }) => {

    const [hoverAction, setHoverAction] = useState(null);


    const logo = teamLogos[player?.team];

    return (
        <>
            {player ? (
                <ListRow
                    key={player}
                // onMouseEnter={() => setHoverAction(index)}
                // onMouseLeave={() => setHoverAction(null)}
                // onClick={() => setFocusAsset(player)}
                // onContextMenu={(e) => {
                //     e.preventDefault(); // Prevents normal browser menu from opening
                //     handleRemove(player);
                // }}
                >
                    <RowIcon>
                        <Img src={logo} alt={player.position} />
                    </RowIcon>

                    <ColInfoStack>
                        <PlayerName>{player.name}</PlayerName>
                        <RowInfoStack>
                            <PlayerCost>Cost: ${player.currentCost}</PlayerCost>
                            <PlayerCost>Projection: {player.dkPoints}</PlayerCost>
                        </RowInfoStack>
                    </ColInfoStack>

                    {/* FIXED: Wrapped click handler in a function arrow so it doesn't auto-fire */}
                    <RemoveButton onClick={handleRemove(player)}>
                        Remove
                    </RemoveButton>
                </ListRow>
            ) :
                <ListRowSlot
                    onMouseEnter={() => setHoverAction(index)}
                    onMouseLeave={() => setHoverAction(null)}
                // onClick={() => setFocusAsset({ id: id, currentStock: item })}
                // onContextMenu={(e) => {
                //     handleRemover(player);
                // }}
                // style={{ cursor: 'pointer', color: "fff" }}
                >
                    {/* <RowIcon>{logo}</RowIcon> */}
                    <ColInfoStack>
                        <RowH1 >{position}</RowH1>
                        <RowH1 style={{ color: "white", fontSize: "10px" }}></RowH1>
                    </ColInfoStack>

                    <SelectButton style={{ marginTop: '10px' }} onClick={(e) => handleFill(e, position)}>Fill</SelectButton>

                </ListRowSlot>

            }
            {/* <TopLine>{position}</TopLine> */}
            {/* <TeamCard> */}
            {/* <ImgWrap>
                    <Img src={app.img} alt={app.alt} />
                </ImgWrap> */}
            {/* <TextWrapper>
                    <TopLine>{player.name}</TopLine>
                    <DetailsWrap>
                        <ImgWrap>
                            <Img src={logo} alt={player.team} />
                        </ImgWrap>
                        <StatsWrap>
                            <FormH4>{player.position}</FormH4>
                            <FormH4>${player.currentCost}</FormH4>
                            <FormH4>{player.dkPoints} </FormH4>
                        </StatsWrap>
                    </DetailsWrap> */}
            {/* <BtnWrap>
                            <BtnLink
                                offset={-80}
                                primary={true}
                                dark={false}
                                dark2={false}
                            >
                                Add
                            </BtnLink>
                        </BtnWrap> */}
            {/* </TextWrapper> */}
            {/* <SelectButton onClick={handleRemove(player)}>Remove</SelectButton> */}
            {/* </TeamCard> */}
        </>
    );
};

export default CaptainTableRow;
